import cx from 'classnames';
import { capfirst } from 'journalize';
import { Component, h } from 'preact';

interface Props {
  info: string;
  isActive: boolean;
  isLive: boolean;
  label: string;
  onClick: (chamber: string) => void;
  stream: string;
}

class StreamTab extends Component<Props> {
  constructor() {
    super();

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.onClick(this.props.stream);
  }

  render() {
    const { info, isActive, isLive, label } = this.props;

    const itemClass = cx('video-nav__item', { 'is-active': isActive });

    return (
      <a
        class={itemClass}
        href="javascript:void(0)"
        onClick={this.onClick}
        ga-on="click"
        ga-event-category="Legislative Livestreams"
        ga-event-action="toggle"
        ga-event-label={label}
      >
        <div class="video-nav__contents">
          <div class="video-nav__text">
            <h3 class="video-nav__label">{label}</h3>
            <p class="video-nav__info">{capfirst(info)}</p>
          </div>
          {/* {isLive && (
            <div class="video-nav__buttons">
              <span class="stream__live-label">Live</span>
            </div>
          )} */}
        </div>
      </a>
    );
  }
}

StreamTab.defaultProps = {
  isActive: false,
  isLive: false,
};

export default StreamTab;
